import { Component } from '@theme/component';

/** Progressive enhancement only: native scrolling remains usable without JS. */
class PeakApprovedReviews extends Component {
  requiredRefs = ['carousel', 'controls', 'previous', 'next'];
  #observer;
  #abort;

  connectedCallback() {
    super.connectedCallback();
    this.#connect();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#connect();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abort?.abort();
    this.#observer?.disconnect();
  }

  #connect() {
    this.#abort?.abort();
    this.#observer?.disconnect();
    this.#abort = new AbortController();
    this.refs.carousel.addEventListener('scroll', () => this.#update(), { passive: true, signal: this.#abort.signal });
    this.#observer = new ResizeObserver(() => this.#update());
    this.#observer.observe(this.refs.carousel);
    this.#update();
  }

  #update() {
    const { carousel, controls, previous, next } = this.refs;
    const offset = Math.abs(carousel.scrollLeft);
    const max = carousel.scrollWidth - carousel.clientWidth;
    controls.hidden = max < 2;
    previous.disabled = offset < 2;
    next.disabled = offset >= max - 2;
  }

  /** Scroll one card toward the start. */
  previous() { this.#move(-1); }

  /** Scroll one card toward the end. */
  next() { this.#move(1); }

  #move(direction) {
    const { carousel } = this.refs;
    const card = carousel.firstElementChild;
    if (!card) return;
    const style = getComputedStyle(carousel);
    const rtl = style.direction === 'rtl' ? -1 : 1;
    carousel.scrollBy({
      left: direction * rtl * (card.getBoundingClientRect().width + parseFloat(style.columnGap)),
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('peak-approved-reviews')) customElements.define('peak-approved-reviews', PeakApprovedReviews);
